/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Evidence confidence (project)
 */
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export type EvidenceConfidenceProjectEnum = 'Rough Guess' | 'Expert Knowledge' | 'Rapid Assessment' | 'Intensive Assessment';

export const EvidenceConfidenceProjectEnum = {
    RoughGuess: 'Rough Guess' as EvidenceConfidenceProjectEnum,
    ExpertKnowledge: 'Expert Knowledge' as EvidenceConfidenceProjectEnum,
    RapidAssessment: 'Rapid Assessment' as EvidenceConfidenceProjectEnum,
    IntensiveAssessment: 'Intensive Assessment' as EvidenceConfidenceProjectEnum
};

marker('Rough Guess');
marker('Expert Knowledge');
marker('Rapid Assessment');
marker('Intensive Assessment');

